import React, { useEffect, useState } from 'react';
import axios from '../../plugins/axios';
// components
import Header from '../../components/Header/Header';
import Form from '../../components/Form/Form';
import Button from '../../components/Button/Button';
import Breadcrumbs from '../../components/Breadcrumbs';
import Alert from '../../components/Alert/Alert';
import Loader from '../../components/Loader/Loader';

// icons
import icon from '../../brand/generated/sidebar/services.svg';
import { useNavigate, useParams } from 'react-router-dom';
import HookForm from '../../components/HookForm/HookForm';
import InputNumeric from '../../components/Inputs/Input/InputNumeric';
import getAdditionalServices from '../../api/services/getAdditionalServices';
import Input from '../../components/Inputs/Input/Input';
import editAdditionalServices from '../../api/services/editAdditionalServices';
import SelectCity from '../../components/Selects/SelectCity';

const formStyles = {
  service: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' },
};

const EditService = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = useState({});
  const inputs = [
    {
      component: Input,
      label: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ',
      name: 'title',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÑÐ»ÑÐ³Ð¸',
      defaultValue: data?.title,
      rules: {
        required: true,
      },
    },
    {
      component: InputNumeric,
      label: 'Ð¦ÐµÐ½Ð°, KZT',
      name: 'price',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐµÐ½Ñ',
      defaultValue: data?.price,
      rules: {
        required: true,
      },
    },
    {
      component: SelectCity,
      label: 'ÐÐ¾ÑÐ¾Ð´',
      name: 'cityId',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐµÐ½Ñ',
      defaultValue: { value: data?.city?.id, label: data?.city?.title },
      rules: {
        required: true,
      },
    },
  ];

  const editService = (values) => {
    setLoading(true);
    editAdditionalServices({ id, ...values })
      .then(() => {
        navigate('/services');
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getAdditionalServices({ id })
      .then((res) => {
        const service = res?.data?.additionalServices?.[0];
        console.log(service);
        setData(service);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <Loader />;

  return (
    <>
      <Header title="ÐÐ¾Ð²Ð°Ñ ÑÑÐ»ÑÐ³Ð°" icon={icon} />
      <Breadcrumbs navigate={'/services'} link={'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ ÑÑÐ»ÑÐ³Ð¸'} currentPage={'ÐÐ¾Ð²Ð°Ñ ÑÑÐ»ÑÐ³Ð°'} />
      <HookForm
        inputs={inputs}
        title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾Ð± ÑÑÐ»ÑÐ³Ðµ'}
        grid={formStyles.service}
        border
        onSubmit={editService}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
      />
    </>
  );
};

export default EditService;
